import React from "react";
import { Navigate } from "react-router-dom";
import { useCoApprovalEnabled } from "@/features/co-review/hooks/useCoApprovalEnabled";

export function RequireCoApproval({ children }: { children: React.ReactNode }) {
  const enabled = useCoApprovalEnabled();
  if (!enabled) return <Navigate to="/" replace />;
  return <>{children}</>;
}
